<template>
    <div class="login-container" :style="portalStyles">
        <div class="login-right" :class="{ 'has-background': portalConfig.background_image }">
            <!-- LOGO显示 -->
            <div v-if="portalConfig.logo" class="portal-logo">
                <img :src="portalConfig.logo" alt="Logo" />
            </div>

            <!-- 标题显示 -->
            <h1 class="portal-title">{{ portalConfig.name }}</h1>
        </div>

        <div class="login-left">
            <div class="form-container">
                <h2>Forgot Password</h2>
                <p class="or-text">Enter your email to receive a reset link</p>
                <el-input v-model="email" placeholder="Email" prefix-icon="el-icon-message" />
                <el-button type="primary" class="login-btn themed-button" :disabled="!isValidEmail"
                    @click="sendResetLink">
                    Send Reset Link
                </el-button>
                <div class="signup-link">
                    Remembered your password?
                    <span @click="goToLogin" class="themed-link-span">Go to Login</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import { Message } from "element-ui";
import { forgotPassword } from "@/api/auth";
import { portalConfigMixin } from "@/mixins/portalConfig"; // 引入混入

export default {
    name: "ForgotPassword",
    mixins: [portalConfigMixin], // 使用混入
    data() {
        return {
            email: ""
        };
    },

    mounted() {
        const workspaceId = localStorage.getItem("workspaceId");
        if (!workspaceId) {
            window.location.href = "https://lazifunnel.com";
        }
    },

    computed: {
        isValidEmail() {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(this.email);
        }
    },

    methods: {
        async sendResetLink() {
            if (!this.isValidEmail) {
                this.$message.error("Please enter a valid email address!");
                return;
            }
            try {
                const res = await forgotPassword({ email: this.email });
                if (res.success) {
                    this.$message.success("Reset link sent! Please check your email.");
                    this.$router.push({ path: "/sign_in" });
                }
            } catch (error) {
                console.error(error);
                // this.$message.error("Failed to send reset link.");
            }
        },

        goToLogin() {
            this.$router.push({ path: "/sign_in" });
        }
    }
};
</script>

<style scoped>
@import "@/assets/css/auth.css";

/* 使用CSS变量应用主题色 */
.login-container {
    --theme-color: #007bff;
    --background-image: none;
}

/* 右侧背景区域 */
.login-right {
    background-color: var(--theme-color);
    background-image: var(--background-image);
    background-size: cover;
    background-position: center;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.login-right.has-background {
    background-color: transparent;
}

/* LOGO样式 */
.portal-logo {
    margin-bottom: 20px;

}

.portal-logo img {
    max-width: 150px;
    max-height: 80px;
    object-fit: contain;
}

/* 标题样式 */
.portal-title {
    color: white;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    text-align: center;
    margin: 0;
}

/* 主题按钮样式 */
.themed-button {
    background-color: var(--theme-color) !important;
    border-color: var(--theme-color) !important;
}

.themed-button:hover {
    background-color: var(--theme-color) !important;
    border-color: var(--theme-color) !important;
    opacity: 0.8;
}

/* 主题链接样式 */
.themed-link-span {
    color: var(--theme-color);
    cursor: pointer;
}

.themed-link-span:hover {
    opacity: 0.8;
}

/* 通用样式 */
.or-text {
    text-align: center;
    margin: 20px 0;
}

.login-btn {
    width: 100%;
    margin-top: 20px;
}

.signup-link {
    text-align: center;
    margin-top: 15px;
}
</style>